import React from "react";
import { InstanceHeader } from "./InstanceHeader";
import { InteractionDisplay } from "./InteractionDisplay";

interface InstanceDisplayProps {
  instance: any;
  instanceIndex: number;
  isRoot: boolean;
  instanceScore?: { score: number | null; explanation: string | null };
}

export function InstanceDisplay({
  instance,
  instanceIndex,
  isRoot,
  instanceScore,
}: InstanceDisplayProps) {
  return (
    <div className="border border-border rounded-lg p-4">
      <InstanceHeader
        instanceName={instance.name || instance.id || `Instance ${instanceIndex + 1}`}
        instanceId={instance.id}
        isRoot={isRoot}
        score={instanceScore?.score}
      />

      {instance.interactions &&
      Array.isArray(instance.interactions) &&
      instance.interactions.length > 0 ? (
        <div className="space-y-4">
          {instance.interactions.map((interaction: any, interactionIndex: number) => (
            <InteractionDisplay
              key={interactionIndex}
              interaction={interaction}
              index={interactionIndex}
            />
          ))}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">No interactions found</p>
      )}
    </div>
  );
}
